import { AxiosResponse } from "../../interface";
import { axiosInstanceWebsite } from "../../instance";

export interface CreateVideo {
    ad_id: string;
    product_id: string;
    ad_text: string;
}

export interface PostVideo {
  avatar_url: string;
  product_id: string;
  ad_text: string;
  ad_id: string;
}

export const createVideo = async (data: CreateVideo) => {
  try {
    const response: AxiosResponse = await axiosInstanceWebsite.post(`/ads/video`, data);
    return response;
  } catch (error: any) {
    console.error("Error creating video:", error);
    throw new Error(error.response?.data?.message || "An error occurred while creating video.");
  }
};

export const getListVideos = async () => {
  try {
    const response: AxiosResponse = await axiosInstanceWebsite.get(`/ads/video/owner`);
    return response;
  } catch (error: any) {
    console.error("Error getting list of videos:", error);
    throw new Error(error.response?.data?.message || "An error occurred while getting list of videos.");
  }
};

export const deleteVideo = async (videoId: string) => {
  try {
    const response: AxiosResponse = await axiosInstanceWebsite.delete(`/ads/videos/${videoId}`);
    return response;
  } catch (error: any) {
    console.error("Error deleting video:", error);
    throw new Error(error.response?.data?.message || "An error occurred while deleting video.");
  }
};

export const getAvatars = async () => {
  try {
    const response: AxiosResponse = await axiosInstanceWebsite.get(`/ads/avatars`);
    return response;
  } catch (error: any) {
    console.error("Error getting avatars:", error);
    throw new Error(error.response?.data?.message || "An error occurred while getting avatars.");
  }
};

export const getVideoByOwnerId = async () => {
  try {
    const response: AxiosResponse = await axiosInstanceWebsite.get(`/ads/videos/owner`);
    return response;
  } catch (error: any) {
    console.error("Error getting video by owner id:", error);
    throw new Error(error.response?.data?.message || "An error occurred while getting video by owner id.");
  }
};

export const postVideo = async (data: PostVideo) => {
  try {
    const response: AxiosResponse = await axiosInstanceWebsite.post(`/ads/videos`, data);
    return response;
  } catch (error: any) {
    console.error("Error posting video:", error);
    throw new Error(error.response?.data?.message || "An error occurred while posting video.");
  }
};

export const getVideoById = async (id: string) => {
  try {
    const response: AxiosResponse = await axiosInstanceWebsite.get(`/ads/videos/${id}`);
    return response;
  } catch (error: any) {
    console.error("Error getting video by id:", error);
    throw new Error(error.response?.data?.message || "An error occurred while getting video by id.");
  }
};